export const FRAME_OPTICAL = 'optical frame';
export const FRAME_SUN = 'sun frame';
export const FRAME_ASSEMBLY = 'frame-assembly';
export const FRAME_ASSEMBLY_CATEGORY_ID = 'FRAME_ASSEMBLY';
export const FRAME_CONFIG = 'FRAME_CONFIG';

export const FRAME_TYPES = [FRAME_OPTICAL, FRAME_SUN, FRAME_ASSEMBLY, FRAME_ASSEMBLY_CATEGORY_ID, FRAME_CONFIG];
export const isFrame = (productType: string) => FRAME_TYPES.includes(productType);
